import React from 'react'
import PropTypes from 'prop-types'

import { Dots, Square } from 'Components/Blocks/_Legacy'
import HeadingSubTitle from 'Components/Blocks/_Legacy/Heading/HeadingSubTitle'
import HeadingTitle from 'Components/Blocks/_Legacy/Heading/HeadingTitle'
import { Motion, Wrapper } from 'Components/UI'

import { useAppContext } from 'Services/AppContext'

import ImageHolder from './ImageHolder'
import {
  Bottom,
  Container,
  Content,
  DotsContainer,
  LeftSide,
  LinkContainer,
  LinkIcon,
  LinkText,
  RightSide,
  Scroll,
  StyledButton,
  Top,
} from './styles'

function Hero({ data }) {
  const { openSupportWidget } = useAppContext()

  return (
    <Container>
      <Wrapper>
        <Content>
          <Motion>
            <Top>
              <LeftSide mr={[0, 4]}>
                <HeadingTitle
                  as="h1"
                  fontSize={[32, 32, 50, 50, 70]}
                  horizontalAlign="left"
                  titleText={{
                    first: { text: data.heroTitleRegular, bold: false },
                    second: { text: data.heroTitleBold, bold: true },
                  }}
                />
              </LeftSide>

              <RightSide>
                <HeadingSubTitle
                  dark
                  fontSize={[14, 16, 16, 20]}
                  horizontalAlign="left"
                  subTitleText={data.heroSubtitle}
                />
                <StyledButton onClick={openSupportWidget}>
                  <LinkContainer>
                    <LinkText>{data.heroDiscussLinkText}</LinkText>

                    <LinkIcon />
                  </LinkContainer>
                </StyledButton>
              </RightSide>
            </Top>
          </Motion>

          <Bottom>
            <Scroll>scroll</Scroll>

            <DotsContainer>
              <Dots
                columns={17}
                corners={[false, true, true, true]}
                margin={4}
                rows={17}
              />
            </DotsContainer>
          </Bottom>
        </Content>
      </Wrapper>

      <ImageHolder data={data?.image} />

      <Square
        angle={-30}
        horizontalAlign={[-550, null]}
        verticalAlign={[null, -300]}
      />
      <Square
        angle={20}
        horizontalAlign={[null, -470]}
        verticalAlign={[0, null]}
      />
    </Container>
  )
}

Hero.propTypes = {
  data: PropTypes.object,
}

export default Hero
